{
  "clearThisNote": "¿Borrar esta nota?",
  "deviceComment": "Comentario",
  "leaveANote": "Deja una nota",
  "newDeviceComment": "Comentario sobre el nuevo dispositivo",
  "thisCommentWillBeVisibleToAllOtherUsersAssociatedWithYourFarmAccount": "Este comentario será visible para todos los demás usuarios asociados a su cuenta de granja."
}
